// Minimal Redux slice for global ImageView - using shared ACTIONS constants
import ACTIONS from 'store/constants';

export type ViewerItem = { url: string; name?: string; type?: 'image' | 'video' };

// Accepts either the collection shape (`items` + `index`, used for galleries) or
// the legacy single-item shape (`imageUrl`/`imageName`/`mediaType`). The reducer
// normalizes both into an items[] + index so the viewer only deals with one shape.
type OpenPayload =
  | { items: ViewerItem[]; index?: number }
  | { imageUrl: string; imageName?: string; mediaType?: 'image' | 'video' };

export const openImageViewer = (payload: OpenPayload) => ({
  type: ACTIONS.IMAGE_VIEWER_OPEN,
  payload,
});

export const closeImageViewer = () => ({ type: ACTIONS.IMAGE_VIEWER_CLOSE });

export type ImageViewerState = {
  isOpen: boolean;
  items: ViewerItem[];
  index: number;
};

const initialState: ImageViewerState = {
  isOpen: false,
  items: [],
  index: 0,
};

export default function imageViewerReducer(
  state: ImageViewerState = initialState,
  action: any
): ImageViewerState {
  switch (action.type) {
    case ACTIONS.IMAGE_VIEWER_OPEN: {
      const p = action.payload || {};
      let items: ViewerItem[];
      let index: number;
      if (Array.isArray(p.items)) {
        items = p.items.filter((it: ViewerItem) => it && it.url);
        index = typeof p.index === 'number' ? p.index : 0;
      } else if (p.imageUrl) {
        items = [{ url: p.imageUrl, name: p.imageName, type: p.mediaType || 'image' }];
        index = 0;
      } else {
        items = [];
        index = 0;
      }
      // Clamp the starting index into range.
      index = Math.min(Math.max(index, 0), Math.max(items.length - 1, 0));
      return { isOpen: items.length > 0, items, index };
    }
    case ACTIONS.IMAGE_VIEWER_CLOSE:
      return initialState;
    default:
      return state;
  }
}
